import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { DiamondFilled, ReverseShadowIcon, ShadowIcon } from '@modernloop/shared/icons';
import { Chip } from '@mui/material';

import { TrainingStatus } from 'src/generated/mloop-graphql';

interface Props {
  status: TrainingStatus;
}

const ModuleMemberTrainingRole: FC<Props> = ({ status }) => {
  const { t } = useTranslation('hiring-dashboard-interviewers');

  switch (status) {
    case TrainingStatus.Shadow:
      return <Chip icon={<ShadowIcon color="inherit" />} label={t('interviewers.moduleMember.shadow')} color="info" />;
    case TrainingStatus.ReverseShadow:
      return (
        <Chip
          icon={<ReverseShadowIcon color="inherit" />}
          label={t('interviewers.moduleMember.reverse')}
          color="primary"
        />
      );

    default:
      return (
        <Chip
          icon={<DiamondFilled color="inherit" tooltip={t('interviewers.moduleMember.trained')} />}
          label={t('interviewers.moduleMember.trained')}
          color="success"
        />
      );
  }
};

export default ModuleMemberTrainingRole;
